module.exports = __webpack_public_path__ + "static/media/something-went-wrong.6d02a32b.svg";